import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIconProps } from '../useIconProps';

var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.959 3.96h3.825l-.009.009L6.25 9.494a.5.5 0 00.707.707l5.526-5.525.005-.006v3.793a.48.48 0 00.96 0V3.5a.5.5 0 00-.5-.5H7.959a.48.48 0 100 .96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.948 4.574a.5.5 0 010 1H4v6.947h6.947v-2.026a.5.5 0 011 0v2.527a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5V5.073a.5.5 0 01.5-.5h2.448z"
  }));
};

ExternalLink.displayName = 'ExternalLink';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ExternalLink.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default ExternalLink;